// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {postReportLayout} from '../../shared/repositories';
import {stripUnsafePathCharacters} from '../../../shared/services/strip-unsafe';
import {successAlertBar} from '../../../shared/services/alert-bar';
import {translate} from '../../../shared/services/translation-service';

export const updateCreateLayoutModal = (property, value) =>

    dispatch => {

        let processedValue;

        if (property === 'layoutName') {

            processedValue = stripUnsafePathCharacters(value);

        } else {

            processedValue = value;

        }

        dispatch({
            property,
            type: actions.UPDATE_CREATE_LAYOUT_MODAL,
            value: processedValue
        });

    };

export const resetCreateLayoutModal = () => ({
    type: actions.RESET_CREATE_LAYOUT_MODAL
});

export const saveReportLayout = params =>

    async (dispatch, getState) => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const response = await postReportLayout(params.reportName, params);

            const savedLayout = {
                ...response,
                columnState: JSON.parse(atob(response.columnState)),
                filterModel: JSON.parse(atob(response.filterModel)),
                sortModel: JSON.parse(atob(response.sortModel))
            };

            const currentLayouts = getState().reportVariant.layouts;

            const updatedLayouts = currentLayouts.filter(item => item.name !== savedLayout.name);

            dispatch({
                data: [...updatedLayouts, savedLayout],
                selectedLayout: savedLayout,
                type: actions.UPDATE_REPORT_GRID_LAYOUTS
            });

            dispatch({
                type: actions.RESET_CREATE_LAYOUT_MODAL
            });

            successAlertBar(translate('LAYOUT_UPDATED_SUCCESSFULLY'));

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/reports/shared/action-creators/create-layout-modal.js